<template>
    <div class="code-view " v-if="palette">
        <active-palette></active-palette>
        <div class="gutter frame fade-in-up">
            <code-component :palette="palette"></code-component>
        </div>
    </div>
</template>

<script>
    import UsesActivePalette from '../../Palette/Views/Components/Palette/UsesActivePalette';
    import ActivePalette from "../../Palette/Views/Components/Palette/ActivePalette";
    import CodeComponent from "./Components/CodeComponent";
    import Transition    from "../../../Lib/Objects/Transition";

    export default {
        extends   : UsesActivePalette,
        components: {CodeComponent, ActivePalette },
        mounted() {
            new Transition('.fade-in-up', 0.5).fadeInUp(32);
        },
    }

</script>
